module.exports = __webpack_public_path__ + "static/media/BundleDeals.8d5e0842.svg";